import React from 'react';
import { RecipeList } from '../components/RecipeList';
// import { EmptyState } from '../components/EmptyState';

/**
 * Favorites Page Component
 * 
 * Features:
 * - Display user's favorite recipes
 * - Quick access to saved recipes
 * - Sort and organize favorites
 * - iOS-optimized favorites interface
 */
export const FavoritesPage: React.FC = () => {
  return (
      <div className="favorites-page">
        <div className="favorites-header mb-6">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Your Favorite Recipes
          </h1>
          <p className="text-gray-600">
            Quick access to your saved recipes
          </p>
        </div>
        
        <div className="favorites-content">
          {/* This would be replaced with actual favorites logic */}
          <RecipeList />
          
          {/* Uncomment when implementing favorites filtering */}
          {/* <EmptyState 
            icon="heart"
            title="No favorites yet"
            description="Start favoriting recipes to see them here"
            actionText="Browse Recipes"
            actionPath="/"
          /> */}
        </div>
      </div>
  );
};

export default FavoritesPage;